<template>
    <div id="layout" class="dashboard-container">


        <div class="app-header">

            <div style="float:left;height: 50px;">
                <img width="140" height="50" style="margin:0px 10px;" v-bind:src="imgUrl" v-on:click="TopMenuGoIndex()">
            </div>


            <div v-for="item in menusTop" v-bind:key="item.url"
                 style="float:left;margin: 0px 15px;cursor: pointer;font-size: 14px;color:#C1C6C8;"
                 v-on:click="TopMenuGo(item.url,item.menuCode)">
                <span v-if="menuTopCur == item.url" style="color: #409EFF;">{{ item.name }}</span>
                <span v-if="menuTopCur != item.url" >{{ item.name }}</span>
            </div>


            <div style="float: right;margin-right: 10px;height: 50px;cursor: pointer;color:#C1C6C8;" v-on:click="loginOut">
                <i class="el-icon-setting"></i>
                <span slot="title" style="padding: 0px 5px;font-size: 14px;">退出</span>
            </div>
            <div style="float: right;margin-right: 10px;height: 50px;cursor: pointer;color:#C1C6C8;" v-on:click="editPassword">
                <i class="el-icon-setting"></i>
                <span slot="title" style="padding: 0px 5px;font-size: 14px;">修改密码</span>
            </div>
            <div style="float: right;margin-right: 10px;height: 50px;color:#C1C6C8;">

                <span style="font-size: 14px;color:white;margin-right:10px;"
                      v-if="staffDTO.institutionDTO != null && staffDTO.institutionDTO.isChain ==1 && staffDTO.institutionDTO.chainType != 'son'">
                    <el-dropdown v-model="currentInstitutionCode" v-if="staffDTO.institutionDTO.listSonInstitutionRelDTO != null" @command="institutionChange">
                      <span class="el-dropdown-link">
                        {{currentInstitutionName}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                           <el-dropdown-item
                                   v-for="item in staffDTO.institutionDTO.listSonInstitutionRelDTO"
                                   v-bind:key="item.sonInstitutionCode"
                                   :command="item.sonInstitutionCode">
                               {{ item.sonInstitutionName }}
                           </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                </span>

                <i class="el-icon-s-custom"></i>
                <span style="font-size: 14px;">『{{staffDTO.roleName}}』{{staffDTO.loginName}}</span>
            </div>
            <!-- <el-tooltip effect="dark" content="护理提醒" placement="bottom">
                <el-badge is-dot style="float: right;cursor: pointer;color:#C1C6C8;line-height: 26px;margin:12px 20px" v-show="showremid"><i class="el-icon-s-claim"></i></el-badge>
            </el-tooltip> -->
            <div style="clear: both"></div>
        </div>



        <div class="app-content" >
            <div class="app-nav" :style="contentStyleObj" v-if="leftMenusShow">
                <app-nav v-bind:isCollapse="isCollapse"></app-nav>
            </div>
            <div class="app-wrap" style="position: relative">
                <div style="width:20px;height:50px;position: absolute;top:0px;left:0px;cursor: pointer" @click="menuTag" v-if="leftMenusShow">
                    <img width="14" height="44" style="margin:3px 0px;" v-bind:src="menuTagImg">
                </div>
                <router-view/>
            </div>
        </div>
    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
                <el-input v-model="oldPassword" placeholder="请输入旧密码" maxlength="10" minlength="6" show-password style="margin-bottom:10px"></el-input>
                <el-input v-model="newPassword" placeholder="请输入登录密码" maxlength="10" minlength="6" show-password></el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="batchDialog=false">取 消</el-button>
                    <el-button type="primary"  @click="editPasswordSure">提交</el-button>
                </div>
            </el-dialog>


    </div>
</template>

<script>

    import AppNav from './AppNav';
    import {getStaffCode,getHeadInsStaffCode, removeToken,getToken} from '@/utils/auth'
    import logo from "../assets/logo2.png";
    import logoYGS from "../assets/logoYGS.png";
    import logoHengyang from "../assets/hengyang.png";
    import logoYiAn from "../assets/logoYiAn.png";
    import menuTagImg from "../assets/menuTag.jpg";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Layout',
        components: {
            AppNav
        },
        data(){
            return{
                showremid:true,
                batchDialog:false,
                staffDTO:JSON.parse(getToken()),
                isCollapse:false,
                leftMenusShow:false,
                imgUrl:logo,
                isks:false,
                menuTagImg:menuTagImg,

                contentStyleObj: {
                    height: '',
                    flexBasis:'200px',
                },

                menusTop:this.$store.state.listMenuTop,
                menuTopCur:'',

                currentInstitutionCode:'',
                currentInstitutionName:'',
                oldPassword:'',
                newPassword:'',

            }
        },

        created(){
            if(this.$institutionUrl == 'http://insapi.ltylao.com:9985/'){
                if(window.location.host=='insadm.ltylao.com'){
                    this.imgUrl = logo
                }else if(window.location.host=='xlyjgyl.ltylao.com'){
                    this.imgUrl = logoHengyang
                }else if(window.location.host=='ahygs-ins.ltylao.com'){
                    this.imgUrl = logoYGS
                }else if(window.location.host=='yian.ltylao.com'){
                  this.imgUrl = logoYiAn
                }
            }else{
                this.imgUrl = logo
            }
            let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
            if(listMenuDTO == null){
                let institutionDTO=this.staffDTO.institutionDTO
                console.log(institutionDTO);
                // console.log(institutionDTO.isChain);
                // console.log(institutionDTO.chainType);
                if(institutionDTO && institutionDTO.isChain ==1 && institutionDTO.chainType != 'son'){
                    this.getListMenu('Staff/StaffMenuAll',getStaffCode());
                }else{
                    this.getListMenu('Staff/StaffMenu',getStaffCode());
                }

            }else{

                let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
                this.$store.commit('update', ['listMenuDTO',listMenuDTO]);

                let listMenuTop = JSON.parse(window.localStorage.getItem('listMenuTop'));
                this.$store.commit('update', ['listMenuTop',listMenuTop]);

                if(this.$route.path=='/home/index'){
                    this.$store.commit('update', ['listMenuLeft','/indexTop']);
                    window.localStorage.setItem('activeMenuTop','/indexTop');
                }else{
                    let listMenuLeft = JSON.parse(window.localStorage.getItem('listMenuLeft'));
                    this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
                }

                let activeMenuTop = window.localStorage.getItem('activeMenuTop');
                this.$store.commit('update', ['activeMenuTop',activeMenuTop]);

                let activeStaffCode = window.localStorage.getItem('activeStaffCode');
                this.$store.commit('update', ['activeStaffCode',activeStaffCode]);

                let activeInstitutionCode = window.localStorage.getItem('activeInstitutionCode');
                this.$store.commit('update', ['activeInstitutionCode',activeInstitutionCode]);

            }


            this.getHight();
            window.addEventListener('resize', this.getHight);




            //init activeInstitutionCode
            let activeInstitutionCode = window.localStorage.getItem('activeInstitutionCode');
            console.log(activeInstitutionCode);
            if(activeInstitutionCode == "null"){
                if(this.staffDTO.institutionDTO != null){
                    if(this.staffDTO.institutionDTO.listSonInstitutionRelDTO != null){
                        if(this.staffDTO.institutionDTO.listSonInstitutionRelDTO.length > 0) {
                            this.currentInstitutionCode = this.staffDTO.institutionDTO.listSonInstitutionRelDTO[0].sonInstitutionCode;
                            this.currentInstitutionName = this.staffDTO.institutionDTO.listSonInstitutionRelDTO[0].sonInstitutionName;
                        }
                    }
                }
            }else{
                let list = this.staffDTO.institutionDTO.listSonInstitutionRelDTO;
                for(let i=0;i<list.length;i++){
                    if(list[i].sonInstitutionCode == activeInstitutionCode){
                        this.currentInstitutionCode =  list[i].sonInstitutionCode;
                        this.currentInstitutionName = list[i].sonInstitutionName;
                    }
                }
            }


        },

        destroyed() {
            window.removeEventListener('resize', this.getHight)
        },

        watch: {

            //监听局部变量
            activeMenuTop(newValue, oldValue) {
                console.log(newValue+"--"+oldValue)
            },
            //监听全局变量
            '$store.state.listMenuTop' : function(val){
                this.menusTop = val;
            },

            '$store.state.activeMenuTop' : function(val){
                this.menuTopCur = val;
                console.log(val)
                if(this.menuTopCur!='/indexTop'){
                    this.leftMenusShow=true
                    let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
                    for(var i=0;i<listMenuDTO.length;i++){
                        if(listMenuDTO[i].url == val){
                            this.leftMenusShow=true
                            let listMenuLeft = listMenuDTO[i].listMenuDTO;
                            this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
                            window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
                        }
                    }
                }else{
                    this.leftMenusShow=false
                }
            },

        },

        methods:{

            menuTag(){

                if(!this.isCollapse){
                    this.isCollapse = true;
                    this.contentStyleObj.flexBasis = 64 + 'px'

                }else{
                    this.isCollapse = false;
                    this.contentStyleObj.flexBasis = 200 + 'px'
                }

            },

            getListMenu(url,staffCode,isRefresh){
                console.log(getHeadInsStaffCode())
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+url,
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5( "timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: staffCode,
                        staffCodeAll:getHeadInsStaffCode()
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        let listMenuDTO = [];
                        listMenuDTO = response.data.data.listMenuDTO;
                        //set listMenuDTO
                        this.$store.commit('update', ['listMenuDTO',listMenuDTO]);
                        window.localStorage.setItem('listMenuDTO', JSON.stringify(listMenuDTO));
                        //set listMenuTop
                        let listMenuDTO2 = [];
                        for(var i=0;i<listMenuDTO.length;i++){
                            var obj = {"name":listMenuDTO[i].name,"menuCode":listMenuDTO[i].menuCode,"url":listMenuDTO[i].url};
                            listMenuDTO2.push(obj);
                        }
                        this.$store.commit('update', ['listMenuTop',listMenuDTO2]);
                        window.localStorage.setItem('listMenuTop', JSON.stringify(listMenuDTO2));
                        if(listMenuDTO.length>0){
                            let listMenuLeft = listMenuDTO[0].listMenuDTO;
                            if(this.$route.query.isks=='true' || isRefresh){
                                this.$store.commit('update', ['activeMenuTop',listMenuDTO[0].url]);
                                window.localStorage.setItem('activeMenuTop',listMenuDTO[0].url);
                                if(listMenuLeft[0].listMenuDTO.length==0){
                                    this.$router.push(listMenuLeft[0].url)
                                }else{
                                    this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
                                }
                                if(isRefresh){
                                    // location.reload()
                                    this.$router.go(0)
                                }
                                this.isks=true
                                // console.log(this.leftMenusShow)
                                this.leftMenusShow=true
                            }else{
                                //set activeMenuTop
                                this.$store.commit('update', ['activeMenuTop','/indexTop']);
                                window.localStorage.setItem('activeMenuTop','/indexTop');
                            }
                            //set listMenuLeft
                            this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
                            window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
                        }

                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            TopMenuGo(url,menuCode){

                //update activeMenuTop
                this.$store.commit('update', ['activeMenuTop',url]);
                window.localStorage.setItem('activeMenuTop', url);

                //update listMenuLeft
                let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
                for(var i=0;i<listMenuDTO.length;i++){
                    if(listMenuDTO[i].menuCode == menuCode){
                        this.leftMenusShow=true
                        let listMenuLeft = listMenuDTO[i].listMenuDTO;
                        this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
                        window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
                        if(listMenuLeft[0].listMenuDTO.length==0){
                            this.$router.push(listMenuLeft[0].url)
                        }else{
                            this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
                        }
                    }
                }

            },
            TopMenuGoIndex(){
                if(!this.isks){
                    this.leftMenusShow=false;
                    this.$router.push('/home/index');
                    this.$store.commit('update', ['activeMenuTop','/indexTop']);
                    window.localStorage.setItem('activeMenuTop', '/indexTop');
                }
            },
            getHight(){
                this.contentStyleObj.height = window.innerHeight - 50 + 'px'

                let mainHeight = window.innerHeight-245;
                if(mainHeight<200){
                    mainHeight = 200;
                }
                this.$store.commit('update', ['tableHeight',mainHeight]);

            },

            loginOut(){
                this.$confirm('是否退出登录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                removeToken();
                    window.localStorage.setItem('activeInstitutionCode', null);
                    window.localStorage.setItem('activeStaffCode', null);
                    window.localStorage.setItem('activeMenuTop', null);
                    window.localStorage.setItem('listMenuDTO', null);
                    window.localStorage.setItem('listMenuTop', null);
                    window.localStorage.setItem('listMenuLeft', null);
                    this.$store.commit('update', ['listMenuDTO',null]);
                    this.$router.push({ path: '/login' })
                }).catch(e=>e)
            },
            editPassword(){
                this.$confirm('是否修改密码?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.batchDialog=true
                }).catch(e=>e)
            },
            editPasswordSure(){
                this.$confirm('确定修改密码?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.updatePassword()
                }).catch(e=>e)
            },
            updatePassword(){
                if(this.newPassword.length<6){
                    this.$message('新密码至少为六位')
                    return;
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Staff/UpdatePWDToStaff',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        oldPassword:this.oldPassword,
                        newPassword:this.newPassword
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.$message('修改成功');
                        this.batchDialog=false;
                        removeToken();
                        window.localStorage.setItem('activeInstitutionCode', null);
                        window.localStorage.setItem('activeStaffCode', null);
                        window.localStorage.setItem('activeMenuTop', null);
                        window.localStorage.setItem('listMenuDTO', null);
                        window.localStorage.setItem('listMenuTop', null);
                        window.localStorage.setItem('listMenuLeft', null);
                        this.$router.push({ path: '/login' })
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });
            },

            institutionChange(command){
                //this.$message('click on item ' + command);

                let list = this.staffDTO.institutionDTO.listSonInstitutionRelDTO;
                for(let i=0;i<list.length;i++){
                    if(list[i].sonInstitutionCode == command){
                        this.currentInstitutionCode =  list[i].sonInstitutionCode;
                        this.currentInstitutionName = list[i].sonInstitutionName;



                        this.$store.commit('update', ['activeInstitutionCode',command]);
                        window.localStorage.setItem('activeInstitutionCode', command);




                        let sonInstitutionStaffDTO = list[i].staffCode;
                        this.$store.commit('update', ['activeStaffCode', sonInstitutionStaffDTO]);
                        window.localStorage.setItem('activeStaffCode', sonInstitutionStaffDTO);
                        this.getListMenu('Staff/StaffMenuAll',getStaffCode(),true);
                        // this.$router.go(0)
                        // console.log(this.$store.state.activeStaffCode);

                    }
                }

            },


        },

    }

</script>



<style lang="scss" scoped>

    .el-dropdown-link {
        cursor: pointer;
        color: #C1C6C8;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }


    .dashboard {
        &-container {
            margin: 0px;
            height: 100%;
        }
    }

    .dashboard-container {

        .app-header {
            color: #fff;
            flex: 0 0 50px;
            background: #10214c;
            height: 50px;
            line-height: 50px;
        }

        .app-content {
            flex: 1;
            display: flex;
            flex-flow: row;

            .app-nav {
                flex: 0 0 200px;
                overflow-y: auto;
                /*background-color: red;*/
            }
            .app-wrap {
                flex: 1;
                overflow: auto;
            }


            /* 设置滚动条的样式 */
            .app-nav::-webkit-scrollbar {
                background-color: #eee;
                width:0px;
            }

            /* 滚动槽 */
            .app-nav::-webkit-scrollbar-track {
                border-radius:0px;
            }

            /* 滚动条滑块 */
            .app-nav::-webkit-scrollbar-thumb {
                border-radius:0px;
                background:#ddd;
            }



        }

    }


</style>
